import { IMakeRequest } from '../utils/request';
import _debounce from 'debounce';

export interface IErrorInfo {
  error: string;
  isAdblock: boolean;
  bannerType: string;
}

/**
 * Этот чудокод дергается в том месте, которое перерисовывается на каждое изменение redux стейта,
 * поэтому добавлен debounce, чтобы апишка пореже дергалась
 * **/
export const sendStats = _debounce((makeRequest: IMakeRequest, errorType: string, bannerType: string) => {
  const headers: [string, string][] = [['Content-Type', 'application/json']];

  makeRequest({
    headers,
    uri: {
      path: '/ajax/stats/',
    },
    body: JSON.stringify([
      {
        name: `adfox.errors.${fixMetric(errorType)}.${fixMetric(bannerType)}`,
        type: 'counter',
        value: '1',
      },
    ]),
    method: 'POST',
  });
}, 1500);

function fixMetric(value: string) {
  return value.replace(/\d+/g, '').replace(/\_/g, '-');
}
